<template>
  <v-card
    id="small-header-top-bar"
    elevation="3"
    v-bind:class="
      isNavigationDialog
        ? 'small-header-top-bar primary'
        : 'small-header-top-bar primary small-header-top-bar-notch'
    "
    :max-width="_getMaxWidth()"
  >
    <v-row
      class="small-header-top-bar-row ma-0 pa-0"
      align="center"
      justify="center"
    >
      <v-col @click="back()" align-self="center" class="ma-0 pa-0" cols="2">
        <v-row
          v-if="(!isDrugsManagement || backMethod) && !closable"
          class="small-header-top-bar-back-button"
          align="center"
          justify="center"
        >
          <v-icon color="white" size="30" class="pb-0 ma-0">{{
            icons.mdiChevronLeft
          }}</v-icon>
        </v-row>
      </v-col>
      <v-col cols="8" align="center" class="ma-0 pa-0">
        <v-row v-if="!title" align="center" class="ma-0 pa-0 vetalfa-row">
          <v-img
            height="44px"
            position="center"
            class="ma-0 pa-0 ml-2"
            contain
            :src="images.logo"
            :lazy-src="images.logo"
          ></v-img>
        </v-row>
        <v-row
          v-else
          align="center"
          justify="center"
          class="
            white--text
            vetalfa-dialog-title
            small-header-top-bar-title
            ma-0
            pa-0
            vetalfa-row
          "
        >
          <p class="pa-0 ma-0">{{ title }}</p>
        </v-row>
      </v-col>
      <v-col class="ma-0 pa-0" cols="2">
        <v-row
          v-if="hasShareOption"
          style="width: 100%"
          class="pa-0 ma-0 pr-4"
          align="center"
          justify="end"
          @click="share()"
        >
          <v-btn icon color="white">
            <v-icon size="18">{{ icons.mdiExportVariant }}</v-icon>
          </v-btn>
        </v-row>
        <v-row
          @click="close()"
          v-else-if="closable"
          style="width: 100%; height: 100%"
          class="pa-0 ma-0"
          align="start"
          justify="center"
        >
          <v-btn icon color="white">
            <v-icon size="22">{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-row>

        <v-row
          v-else-if="hasSlotOption"
          class="pa-0 ma-0 pr-4"
          align="center"
          justify="end"
        >
          <slot></slot>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style>
.small-header-top-bar-back-button {
  position: absolute;
  top: calc(30px + env(safe-area-inset-top));
  left: 16px;
  cursor: pointer;
}
.small-header-top-bar {
  border-radius: 0px !important;
  border-bottom-left-radius: 0px;
  width: 100%;
  background: linear-gradient(90deg, #002f56, 39%, #00728a);
}
.small-header-top-bar-notch {
  padding-top: constant(safe-area-inset-top) !important;
  padding-top: env(safe-area-inset-top) !important;
}
.small-header-top-bar-row {
  width: 100%;
  height: 100%;
  height: 64px !important;
}
.small-header-top-bar-title {
  word-break: normal;
}
</style>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import imagesConstants from "@/constants/images.js";
import messages from "@/constants/messages.js";
import {
  mdiArrowLeft,
  mdiShare,
  mdiChevronLeft,
  mdiClose,
  mdiExportVariant,
} from "@mdi/js";
import { analytics } from "@/plugins/firebase.js";

export default {
  name: "SmallHeader",
  props: {
    title: {
      type: String,
      default: null,
    },
    hasShareOption: {
      type: Boolean,
      default: false,
    },
    hasSlotOption: {
      type: Boolean,
      default: false,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
    backMethod: {
      type: Function,
      default: null,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    isNavigationDialog: {
      type: Boolean,
      default: false,
    },
    confirmationObject: {
      default: null,
    },
  },
  computed: {
    ...mapGetters("general", ["from"]),
    shareObj: function () {
      let url = this._encrypt(
        JSON.stringify({
          path: this.$route.path,
          query: this.$route.query,
        }),
        true
      );
      url = `https://app.vetalfa.com/%23/share/${url}`;
      url = `https://vetalfa.page.link/?isi=1542661563&ibi=br.com.vetalfa&apn=br.com.vetalfa&link=${url}`;
      if (this._isMobile() && !this._isAndroid()) {
        return {
          title: messages.SHARE_TITLE,
          text: url,
          url: url,
        };
      }
      return {
        title: messages.SHARE_TITLE,
        text: messages.SHARE_TEXT,
        url: url,
      };
    },
  },

  mounted() {},

  methods: {
    ...mapActions("general", ["copyToClipboard", "routeBack"]),
    ...mapMutations("general", ["setConfirmModel"]),
    share() {
      this.analytics.logEvent("share", { url: this.shareObj.url });
      if (navigator.share) {
        navigator.share(this.shareObj);
      } else {
        this.copyToClipboard(this.shareObj.url);
      }
    },
    close() {
      this.backMethod();
    },
    back(backConfirmation) {
      if (this.isDrugsManagement) {
        this.backMethod();
      } else if (!!this.confirmationObject && !backConfirmation) {
        this.setConfirmModel({
          ...this.confirmationObject,
          active: true,
          callback: this.backConfirmation,
        });
      } else {
        this.routeBack();
      }
    },
    backConfirmation() {
      this.back(true);
    },
  },
  data() {
    return {
      images: {
        logo: imagesConstants.LOGO_SMALL_HEADER,
      },
      icons: {
        mdiArrowLeft,
        mdiShare,
        mdiChevronLeft,
        mdiClose,
        mdiExportVariant,
      },
      analytics,
    };
  },
  created() {},
};
</script>